import { RETRIEVE_FINAL_APPROVALS, CREATE_FINAL_APPROVER, UPDATE_FINAL_APPROVER, DELETE_FINAL_APPROVER } from '../../actions/types';

const initialState = {
    items: [],
    totalItems: 0,
    totalPages: 1,
    currentPage: 1,
};

function finalApprovalReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case RETRIEVE_FINAL_APPROVALS:
            return {
                ...state,
                items: payload.data,
                totalItems: payload.totalItems,
                totalPages: payload.totalPages,
                currentPage: payload.currentPage,
            };

        case CREATE_FINAL_APPROVER:
            return {
                ...state,
                items: [payload, ...state.items],
                totalItems: state.totalItems + 1,
            };

        case UPDATE_FINAL_APPROVER:
            return {
                ...state,
                items: state.items.map((item) => (item.id === payload.id ? payload : item)),
            };

        case DELETE_FINAL_APPROVER:
            return {
                ...state,
                items: state.items.filter(({ id }) => id !== payload.id),
                totalItems: state.totalItems - 1,
            };

        default:
            return state;
    }
}

export default finalApprovalReducer;
